import { render } from "./NursingView.vue?vue&type=template&id=544bc090"
import script from "./NursingView.vue?vue&type=script&lang=js"
export * from "./NursingView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__